import { createAppSyncLink, AUTH_TYPE } from 'aws-appsync'
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';

interface Config {
    token: string,
    apiKey: string, // Non-sensitive API key, there is additional auth server side using user tokens
    url: string,
    region: string
}

export default function createClient(config: Config){
    const httpLink = createHttpLink({
        uri: config.url,
    });

    const awsLink = createAppSyncLink({
        url: config.url,
        region: config.region,
        auth: {
            type: AUTH_TYPE.API_KEY,
            apiKey: config.apiKey
        },
        complexObjectsCredentials: () => null
    })

    const middlewareLink = new ApolloLink((operation, forward) => {
        operation.setContext({
          headers: {
            'x-amz-security-token': config.token
          }
        });
        return forward(operation);
    });

    return new ApolloClient({
        link: ApolloLink.from([middlewareLink, awsLink, httpLink]),
        cache: new InMemoryCache({
            dataIdFromObject: (object: any) => {
                switch (object.__typename) {
                  case 'UserConversation': return object.conversationId;
                  case 'onUpdateUserConversation': return object.conversationId;
                  default: return object.id;
                }
              }
        })
    });
}